import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-250bc142"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xl txtLeft" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Facility", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Service Line", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Department", -1))
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Status", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Shift Code", -1))
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "col" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Skill", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Date", -1))
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "col" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Start Time", -1))
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "col" }
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "End Time", -1))
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "col" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col" }
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Charge", -1))
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { class: "col" }
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Float", -1))
const _hoisted_53 = ["innerHTML"]
const _hoisted_54 = { class: "col" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Cancelled", -1))
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = {
  key: 0,
  class: "row"
}
const _hoisted_59 = { class: "col" }
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Cancellation Reason", -1))
const _hoisted_62 = ["value"]
const _hoisted_63 = { class: "col" }
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Unscheduled Absence", -1))
const _hoisted_66 = ["value"]
const _hoisted_67 = { class: "col-xl-5" }
const _hoisted_68 = { class: "form-group" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "txtLeft" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "font-weight-bold" }, "Notes")
], -1))
const _hoisted_70 = { id: "assignmentedit-notes-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddViewNote = _resolveComponent("AddViewNote")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("input", {
                class: "form-control",
                readonly: "",
                value: _ctx.FacilityName
              }, null, 8, _hoisted_7)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("input", {
                class: "form-control",
                readonly: "",
                value: _ctx.ClusterName
              }, null, 8, _hoisted_11)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("input", {
                class: "form-control",
                readonly: "",
                value: _ctx.DepartmentName
              }, null, 8, _hoisted_15)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("input", {
                class: "form-control",
                readonly: "",
                value: _ctx.ProductiveDescription
              }, null, 8, _hoisted_20)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("input", {
                class: "form-control",
                readonly: "",
                value: _ctx.ShiftCode
              }, null, 8, _hoisted_24)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("input", {
                class: "form-control",
                readonly: "",
                value: _ctx.SkillLevelDescription
              }, null, 8, _hoisted_28)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("input", {
                class: "form-control",
                readonly: "",
                value: _ctx.ShiftDate
              }, null, 8, _hoisted_33)
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("input", {
                    class: "form-control",
                    readonly: "",
                    value: _ctx.StartTime
                  }, null, 8, _hoisted_39)
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("input", {
                      class: "form-control",
                      readonly: "",
                      value: _ctx.EndTime
                    }, null, 8, _hoisted_43)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("div", {
                    class: "assignmentTxt",
                    innerHTML: _ctx.ChargeStatus
                  }, null, 8, _hoisted_49)
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createElementVNode("div", {
                    class: "assignmentTxt",
                    innerHTML: _ctx.FloatStatus
                  }, null, 8, _hoisted_53)
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createElementVNode("div", {
                    class: "assignmentTxt",
                    innerHTML: _ctx.CancelStatus
                  }, null, 8, _hoisted_57)
                ])
              ])
            ])
          ])
        ]),
        (_ctx.showCancelReason)
          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _hoisted_61,
                  _createElementVNode("input", {
                    class: "form-control",
                    readonly: "",
                    value: _ctx.CancelReason
                  }, null, 8, _hoisted_62)
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _hoisted_65,
                  _createElementVNode("input", {
                    class: "form-control",
                    readonly: "",
                    value: _ctx.UnscheduledAbsenceText
                  }, null, 8, _hoisted_66)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_67, [
        _createElementVNode("div", _hoisted_68, [
          _hoisted_69,
          _createElementVNode("div", _hoisted_70, [
            _createVNode(_component_AddViewNote)
          ])
        ])
      ])
    ])
  ]))
}